import styled from 'styled-components';

export const RejectionWrapper = styled.div`
  display: flex;
`;

export const TextWrapper = styled.div`
  margin-left: ${({ theme }) => theme.spacing4}px;
`;
